// жанр после префикса должен соответствовать
// жанру в base/src/enums/EAppsGenreEng.ts

export enum ERefsApps {
	SEO_GAMES = 'seogames',

	PAGE_INSTALLED = 'mwinst',
	PAGE_NEW = 'mwnew',
	PAGE_POPULAR = 'mwsugg',
	PAGE_STRATEGY = 'mwstrategy_games',
	PAGE_LUCKY = 'mwlucky_games',
	PAGE_ROLEPLAY = 'mwrole_play_games',
	PAGE_CASUAL = 'mwcasual_games',
	PAGE_LOGIC = 'mwlogic_games',
	PAGE_ROWS = 'mwgames_3_in_row',
	PAGE_EXTERNAL = 'mwexternal_games',

	LINE_INSTALLED = 'mwcinst',
	LINE_NEW = 'mwcnew',
	LINE_SALES = 'mwccatsale',
	LINE_POPULAR = 'mwcajax_sugg',
	LINE_SHOWCASE = 'mwcshowcase',
	LINE_STRATEGY = 'mwc_strategy_games',
	LINE_LUCKY = 'mwc_lucky_games',
	LINE_ROLE_PLAY = 'mwc_role_play_games',
	LINE_CASUAL = 'mwc_casual_games',
	LINE_LOGIC = 'mwc_logic_games',
	LINE_THREE_IN_ROW = 'mwc_games_3_in_row',
	LINE_EXTERNAL = 'mwc_external_games',
}

